"use client";
import { styled } from "@mui/material/styles";
import { Link } from "@nxt-costco-com/forge-components";
import { SpaceXs, SpaceSm, FontWeightBold, RadiusMd } from "@nxt-costco-com/forge-design-tokens";
const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== "backgroundColor" && prop !== "color"
})(({ backgroundColor, color }) => ({
  backgroundColor: backgroundColor.hex,
  borderRadius: RadiusMd,
  color: color.hex,
  flexShrink: 0,
  fontWeight: FontWeightBold,
  padding: `${SpaceXs} ${SpaceSm}`,
  textAlign: "center",
  textDecoration: "none",
  display: "block",
  "&.not-visible": {
    display: "none"
  }
}));
export {
  StyledLink
};
